import { PageInfo } from 'src/assets/types/interface/page-info.interface';

export async function buildCompanyEditPageInfo(): Promise<PageInfo> {
  return {
    identification: '',
    title: 'Configuração',
    pagesAbove: [
      {
        title: 'Home',
        url: '/home',
        description: 'Home',
      },
      {
        title: 'Perfil da empresa',
        url: '/configuracoes/perfil-empresa',
        description: 'Detalhamento da empresa',
      },
    ],
  };
}
